// src/pages/Corporate.jsx
import PageBanner from '../components/ui/PageBanner';
import { corporateServices } from '../data';
import corporateHero from '../assets/hero-2.png';
import './Corporate.css';

const PACKAGES = [
  { icon: '📋', title: 'Basic Wellness', price: 'AED 299/employee', features: ['Annual blood work', 'BMI assessment', 'Blood pressure check'] },
  { icon: '⭐', title: 'Standard Wellness', price: 'AED 599/employee', features: ['All Basic tests', 'ECG screening', 'Diabetes panel', 'Chest X-ray'] },
  { icon: '👑', title: 'Premium Wellness', price: 'AED 999/employee', features: ['All Standard tests', 'Full executive panel', 'Specialist consultation', 'Mental health screen'] },
];

export default function Corporate() {
  return (
    <>
      <PageBanner title="Corporate Wellness" crumbs={['Home', 'Corporate Wellness']} />

      {/* Intro */}
      <section className="section">
        <div className="section-inner">
          <div className="corp__layout">
            <div>
              <p className="section-label">Corporate Wellness Programs</p>
              <h3 className="section-title">Invest in Your Team's Health</h3>
              <p className="section-text">
                Capital Care International Hospital offers comprehensive corporate wellness programs
                designed to keep your workforce healthy, productive, and engaged. Our expert
                team works with organizations to create customized health solutions.
              </p>
              <ul className="corp__services">
                {corporateServices.map(s => (
                  <li key={s} className="corp__service-item">
                    <span className="corp__check">✓</span> {s}
                  </li>
                ))}
              </ul>
              <button className="btn-primary corp__cta">Get a Quote</button>
            </div>
            <div className="corp__hero-img">
              <img src={corporateHero} alt="Capital Care International Hospital reception and facilities" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* Packages */}
      <section className="section section--gray">
        <div className="section-inner">
          <div className="corp__pkg-header">
            <p className="section-label">Plans</p>
            <h3 className="section-title">Corporate Wellness Packages</h3>
          </div>
          <div className="corp__pkg-grid">
            {PACKAGES.map((pkg, i) => (
              <div key={pkg.title} className={`corp__pkg-card card ${i === 1 ? 'corp__pkg-card--featured' : ''}`}>
                <div className="corp__pkg-icon">{pkg.icon}</div>
                <h3 className="corp__pkg-title">{pkg.title}</h3>
                <p className="corp__pkg-price">{pkg.price}</p>
                <ul className="corp__pkg-features">
                  {pkg.features.map(f => (
                    <li key={f}><span>✓</span> {f}</li>
                  ))}
                </ul>
                <button className={i === 1 ? 'btn-primary' : 'btn-outline'}>
                  Choose Plan
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
